import { gql } from 'graphql-request';

export const ROUTE_CARD_FIELDS = `
  id hikeDayId hikeName dayNumber dayName
  paceKmh climbMinutesPer100m startDate startMinutes timeZone
  gridCrs gridKey gridName partySize partyNames leaderMobile
  shared shareUrl locked legCount
  points { index distanceMeters lng lat elevationMeters gridRef name note escape restMinutes arriveMinutes leaveMinutes }
  legs {
    index label fromIndex toIndex distanceMeters cumulativeDistanceMeters ascentMeters descentMeters
    gridBearing magneticBearing movingMinutes arriveMinutes leaveMinutes
  }
  totals { distanceMeters ascentMeters descentMeters movingMinutes restMinutes finishMinutes spareDaylightMinutes }
  declinationDegrees gridToMagneticDegrees sunrise sunset updatedAt
`;

export const GetRouteCard = gql`
  query GetRouteCard($hikeDayId: ID!, $startFrom: RouteCardStartFromEnum) {
    routeCard(hikeDayId: $hikeDayId, startFrom: $startFrom) { ${ROUTE_CARD_FIELDS} }
  }
`;

export const GetSharedRouteCard = gql`
  query GetSharedRouteCard($token: String!) {
    sharedRouteCard(token: $token) { ${ROUTE_CARD_FIELDS} }
  }
`;

export const SaveRouteCard = gql`
  mutation SaveRouteCard($input: SaveRouteCardInput!) {
    saveRouteCard(input: $input) { ${ROUTE_CARD_FIELDS} }
  }
`;

export const SetRouteCardSharing = gql`
  mutation SetRouteCardSharing($input: SetRouteCardSharingInput!) {
    setRouteCardSharing(input: $input) { ${ROUTE_CARD_FIELDS} }
  }
`;
